import {
   FormHelperText,
   FormLabel,
   FormControl,
   PinInput,
   PinInputField,
   HStack,
} from '@chakra-ui/react';
import { _js } from '@ifixit/localize';

interface CodeInputProps {
   value: string;
   onChange: (value: string) => void;
   inputId?: string;
}

export const CodeInput = ({ value, onChange, inputId = 'code-input' }: CodeInputProps) => (
   <FormControl width="100%" alignItems="center" display="flex" flexDirection="column">
      <FormLabel mb={2}>{_js('6-digit code')}</FormLabel>
      <HStack spacing={3} justify="flex-start">
         <PinInput
            id={inputId}
            size="md"
            type="number"
            otp
            placeholder=""
            value={value}
            onChange={onChange}
            focusBorderColor="brand.500"
            errorBorderColor="red.500"
         >
            <PinInputField aria-required="true" />
            <PinInputField aria-required="true" />
            <PinInputField aria-required="true" />
            <PinInputField aria-required="true" />
            <PinInputField aria-required="true" />
            <PinInputField aria-required="true" />
         </PinInput>
      </HStack>
      <FormHelperText mt={1}>
         {_js('Enter the 6-digit code you received in your email.')}
      </FormHelperText>
   </FormControl>
);
